document.addEventListener("DOMContentLoaded", function () {
  const ctlItems = document.querySelectorAll(".ctl__item");

  ctlItems.forEach(item => {
    const btn = item.querySelector(".ctl__btn");
    const select = item.querySelector(".ctl__select");
    const selectwrapper = item.querySelector(".ctl__select-wrapper");
    const singleVariantInput = item.querySelector(".ctl__variant-single");

    if (!btn) return;

    if (!btn.dataset.initialHtml) {
      btn.dataset.initialHtml = btn.innerHTML;
    }

    if (singleVariantInput) {
      btn.addEventListener("click", () => {
        addToCart(singleVariantInput.value, btn);
      });
      return;
    }

    if (select) {
      select.addEventListener("change", () => {
        selectwrapper.classList.remove("select_variant");
      });

      btn.addEventListener("click", () => {
        const variantId = select.value;

        if (!variantId) {
          selectwrapper.classList.add("select_variant");
          return;
        }

        addToCart(variantId, btn);
      });
    }
  });

  function setButtonState(button, html, { disable = false } = {}) {
    button.innerHTML = html;
    button.disabled = !!disable;
    button.classList.toggle("is-loading", !!disable);
  }

  function restoreButton(button, delay = 1000) {
    const original = button.dataset.initialHtml || "Add to cart";
    setTimeout(() => setButtonState(button, original, { disable: false }), delay);
  }

  function addToCart(variantId, button) {
    if (!variantId || button.disabled) return;

    setButtonState(button, "<span>Adding...</span>", { disable: true });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(res => {
      if (!res.ok) throw new Error("Add to cart failed");
      return res.json();
    })
    .then(() => {
      document.dispatchEvent(new CustomEvent("cart:refresh"));

      setTimeout(() => {
        const openCartButton = document.querySelector(".js-mini-cart-trigger");
        if (openCartButton) openCartButton.click();
      }, 100);

      setButtonState(button, "<span>Added!</span>", { disable: true });
      restoreButton(button, 1000); 
    })
    .catch(() => {
      setButtonState(button, "<span>Error</span>", { disable: true });
      restoreButton(button, 1200);
    });
  }
});
